import { cn } from '@/lib/utils/cn';

interface PlanFeaturePillProps {
    icon: string;
    header: string;
    description: string;
    isPro?: boolean;
}

export const PlanFeaturePill = ({ icon, header, description, isPro = false }: PlanFeaturePillProps) => {
    return (
        <div className='bg-bg-canvas flex flex-row gap-2 rounded-full p-2.5 shadow-sm'>
            <div
                className={cn(
                    'bg-semantic-accent-subtle my-auto flex size-7 shrink-0 items-center justify-center rounded-full p-1',
                    {
                        'bg-brand-main': isPro,
                    }
                )}
            >
                <span className='text-sm leading-none'>{icon}</span>
            </div>
            <div className='flex flex-col gap-0.5'>
                <span className='text-semantic-fg-base text-xs leading-tight font-bold'>{header}</span>
                <span className='text-semantic-fg-muted text-[10px] leading-tight font-medium'>{description}</span>
            </div>
        </div>
    );
};
